module.exports = __webpack_public_path__ + "static/media/avatar41.3c9987f4.png";